<!-- message-detail-bottom-sheet.component.html -->
<!-- Veste BEIZY del bottom sheet: testata bianca a filo dei bordi separata dal
     tratto nero 2px, corpo su fondo panna con le superfici bianche bordate. -->
<div class="message-detail-container">
  <!-- Header -->
  <div class="message-header d-flex justify-content-between align-items-center">
    <h4 class="m-0">Dettaglio Notifica</h4>
    <button
      mat-icon-button
      (click)="closeBottomSheet()"
      aria-label="Chiudi"
      class="custom-button-border"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Area scrollabile: intestazione del messaggio su fondo bianco, poi il
       contenuto su fondo panna. -->
  <div class="message-detail-scroll">

  <!-- Chi/quando/di che tipo: fascia bianca a filo dei bordi, chiusa in basso
       dal tratto nero 2px (al posto del vecchio mat-divider). -->
  <div class="message-detail-intro">

    <!-- Message Type Chip + badge "Nuovo" se la notifica era ancora da leggere -->
    <div class="mb-3 d-flex align-items-center flex-wrap gap-2">
      <mat-chip
        [color]="getMessageTypeColor(data.message.type)"
        variant="outlined"
        class="type-chip">
        <mat-icon matChipAvatar>{{ getMessageTypeIcon(data.message.type) }}</mat-icon>
        {{ getMessageTypeLabel(data.message.type) }}
      </mat-chip>

      <mat-chip class="new-message-chip" *ngIf="isUnread">
        Nuovo
      </mat-chip>
    </div>

    <!-- Message Title -->
    <h2 class="message-title mb-3">
      {{ data.message.title || 'Nessun titolo' }}
    </h2>

    <!-- Sender and Date -->
    <div class="message-meta">
      <p class="m-0 text-muted">
        <strong>Da:</strong> {{ data.message.sender || 'Sconosciuto' }}
      </p>
      <p class="m-0 text-muted">
        <strong>Data:</strong> {{ formatDate(data.message.date) }}
      </p>
    </div>

  </div>

  <!-- Corpo su fondo panna -->
  <div class="message-detail-body">

  <!-- Message Content -->
  <div class="message-content mb-4">
    <h5 class="mb-3">Contenuto</h5>
    <div class="message-text">
      {{ data.message.message || 'Nessun contenuto' }}
    </div>
  </div>

  <!-- Attachment Section -->
  <div *ngIf="hasAttachment(data.message)" class="attachment-section">
    <mat-divider class="mb-3"></mat-divider>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h5 class="mb-1">Allegato</h5>
        <p class="text-muted m-0">Clicca per visualizzare il file</p>
      </div>
      <button
        matButton="filled"
        (click)="downloadAttachment()"
        class="attachment-button izy-button-primary custom-button-border">
        <mat-icon>attach_file</mat-icon>
        Apri Allegato
      </button>
    </div>
  </div>

  </div><!-- /message-detail-body -->

  </div><!-- /message-detail-scroll -->
</div>
